import { requestLaravel } from "../../../../../utils/api";
import { envConfig } from "../../../../../utils/config";
import { ApiResponse } from "../../../core/_models";
import { CategoryColor, IEvent, IEventForm, IEventFormResponse, IReminder } from "./type";

export function getCalenderEvents(payload: {
  is_public_page?: boolean;
}, signal?: AbortSignal) {
  return requestLaravel<ApiResponse<IEvent[]>>("/calendar/events/list", {
    ...payload,
    is_public_page: payload.is_public_page ? 1 : 0,
  }, { signal });
}

export function getPublicCalendarData(signal?: AbortSignal) {
  return requestLaravel<ApiResponse<{ events: IEvent[], categories: CategoryColor[] }>>(
    "/calendar/public-data",
    {},
    { signal }
  );
}

export const getPublicCalendarJsonData = (signal?: AbortSignal): Promise<{ events: IEvent[], categories: CategoryColor[] }> => {
  return fetch(`${envConfig.APP_PLATFORM_API_URL}/cache/calendar/public_calendar.json`, { signal })
    .then(response => response.json())
    .then(data => ({ events: data.events, categories: data.categories }))
    .catch(error => Promise.reject(error));
}

export function createCalenderEvent(payload: IEventForm) {
  return requestLaravel<ApiResponse<IEventFormResponse>>("/calendar/events/save", payload);
}

export function updateCalendarEvent(
  payload:
    | IEventForm
    | { event_id: number; reminders: IReminder[]; personal_reminders_on_global?: 0 | 1 },
) {
  return requestLaravel<ApiResponse<IEventFormResponse>>("/calendar/events/update", payload);
}

export function deleteCalenderEvent(payload: { event_id: number }) {
  return requestLaravel<ApiResponse<IEvent>>("/calendar/events/delete", payload);
}

export function getEventCategoryAndColors(signal?: AbortSignal) {
  return requestLaravel<ApiResponse<CategoryColor[]>>("/calendar/categories/list", {}, { signal });
}

export function getAvailableFrequenciesOfOccurrenceType() {
  return requestLaravel<ApiResponse<{ frequencies: string[] }>>(
    "/calendar/occurrence-frequencies/list",
    {},
  );
}
